<div class="flex flex-col w-full min-w-0 sm:inset-0 sm:overflow-hidden h-[71vh]">
  <mat-drawer-container class="flex-auto sm:h-full">
    <mat-drawer class="dark:bg-gray-900" [ngClass]="{ 'w-full lg:w-2/4': drawerOpened }" [autoFocus]="false"
      [position]="drawerPosition" [mode]="drawerMode" [opened]="drawerOpened" #drawer>
      <div>
        <mat-card class="modal" *ngIf="trailActionView === 'extend-trial' && extendTrailData">
          <mat-card-header>
            <mat-card-title class="text-lg font-medium">Extend Trial</mat-card-title>
            <div class="spacer">&nbsp;</div>
            <button class="mini-form-field" mat-icon-button aria-label="close modal icon" matTooltip="Close"
              (click)="drawerOpened = false">
              <mat-icon>close</mat-icon>
            </button>
          </mat-card-header>
          <mat-divider></mat-divider>
          <mat-card-content class="my-4" fuseScrollbar>
            <mat-form-field class="w-full mb-4">
              <mat-label>From date</mat-label>
              <input matInput [matDatepicker]="picker1" [(ngModel)]="extendTrailData.trial_start_date" [min]="today"
                [max]="maxDate" disabled autocomplete="off" name="startDate">
              <mat-hint>MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="w-full mb-4">
              <mat-label>To date</mat-label>
              <input matInput [matDatepicker]="picker2" [(ngModel)]="extendTrailData.trial_end_date" [min]="today"
                [max]="maxDate" autocomplete="off" name="toDate">
              <mat-hint>MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
            <!-- <mat-form-field class="w-full mb-4">
              <mat-label>Choose Trail Days</mat-label>
              <input matInput placeholder="Choose Trail Days" type="date" required name="traildays" [min]="today"
                [max]="maxDate" [(ngModel)]="extendTrailData.trial_end_date" />
            </mat-form-field> -->
            <mat-form-field class="w-full mb-4">
              <mat-label>Reason</mat-label>
              <textarea matInput placeholder="Add Reason" required name="reason"
                [(ngModel)]="extendTrailData.reason"></textarea>
            </mat-form-field>
            <div class="flex items-center justify-end mt-4 p-2 border-t bg-gray-50 dark:bg-transparent ml-auto">
              <button class="ml-auto" mat-button [matTooltip]="'Cancel'"
                (click)="drawerOpened = false ;changeDistributorData={}">
                Cancel
              </button>
              <button class="ml-2" mat-flat-button [color]="'primary'" type="button" appPreventMultiClick
              [disabled]="!(extendTrailData.trial_end_date && extendTrailData.reason)"
                [matTooltip]="'Save'" (click)="saveExtent(extendTrailData)">
                Save
              </button>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="modal" *ngIf="trailActionView === 'change-distributor' && changeDistributorData">
          <mat-card-header>
            <mat-card-title class="text-lg font-medium">Change Distributor</mat-card-title>
            <div class="spacer">&nbsp;</div>
            <button class="mini-form-field" mat-icon-button aria-label="close modal icon" matTooltip="Close"
              (click)="drawerOpened = false">
              <mat-icon>close</mat-icon>
            </button>
          </mat-card-header>
          <mat-divider></mat-divider>
          <mat-card-content class="my-4" fuseScrollbar>
            <mat-form-field class="w-full mb-4">
              <mat-label>Choose Distributor</mat-label>
              <mat-select class="" placeholder="Choose Distributor" name="ChooseDistributor" required
                [(ngModel)]="changeDistributorData.distributor_id">
                <mat-option *ngFor="let Distributor of distributorData" [value]="Distributor.id">{{
                  Distributor.distributor_name
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="w-full mb-4">
              <mat-label>Reason</mat-label>
              <textarea matInput placeholder="Add Reason" required name="reason"
                [(ngModel)]="changeDistributorData.reason"></textarea>
            </mat-form-field>
            <div class="flex items-center justify-end mt-4 p-2 border-t bg-gray-50 dark:bg-transparent ml-auto">
              <button class="ml-auto" mat-button [matTooltip]="'Cancel'"
                (click)="drawerOpened = false;changeDistributorData={}">
                Cancel
              </button>
              <button class="ml-2" mat-flat-button [color]="'primary'" type="button" appPreventMultiClick
                [disabled]="!(changeDistributorData.distributor_id && changeDistributorData.reason)"
                [matTooltip]="'Save'" (click)="saveDistributor(changeDistributorData)">
                Save
              </button>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="modal" *ngIf="trailActionView === 'partner-stats' && partnerstatsDataValue.length > 0">
          <mat-card-header>
            <div class="flex items-center">
              <mat-card-title class="text-lg font-medium">Partner Stats</mat-card-title>
              <button class="ml-2 mt-2" type="button" matTooltip="Download as XLSx" (click)="downloaddata()">
                <mat-icon color="primary">download</mat-icon>
              </button>
            </div>
            <div class="spacer">&nbsp;</div>
            <button class="mini-form-field" mat-icon-button aria-label="close modal icon" matTooltip="Close"
              (click)="drawerOpened = false;partnerstatsDataValue=[];partnerstatsData={};fromDateField='';toDateField='' ">
              <mat-icon>close</mat-icon>
            </button>
          </mat-card-header>
          <mat-divider></mat-divider>
          <mat-card-content class="my-4" fuseScrollbar>
            <div class="">
              <div class="flex relative flex-row items-center justify-center">
                <mat-form-field class="mini-form-field flex-auto">
                  <mat-label>From date</mat-label>
                  <input matInput [matDatepicker]="picker1" [(ngModel)]="fromDateField"
                    (dateChange)="changePertnerStats()" [max]="todayField" autocomplete="off" name="startDate">
                  <mat-hint>MM/DD/YYYY</mat-hint>
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="ml-2 mini-form-field flex-auto">
                  <mat-label>To date</mat-label>
                  <input matInput [matDatepicker]="picker2" [(ngModel)]="toDateField"
                    (dateChange)="changePertnerStats()" [max]="todayField" name="endDate">
                  <mat-hint>MM/DD/YYYY</mat-hint>
                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
                <div class="mini-form-field" *ngIf="fromDateField || toDateField">
                  <button class="ml-2" mat-flat-button type="button" [color]="'warn'" appPreventMultiClick
                    [matTooltip]="'Reset'" (click)="resetDate()">
                    Reset
                  </button>
                </div>
              </div>
              <div class=" w-full rounded px-6 py-0.5 ring-1 mt-4" fuseScrollbar
                *ngIf="partnerstatsDataValue && partnerstatsDataValue.length>0">
                <table class="table-auto">
                  <thead>
                    <tr class="border-b">
                      <th class="py-3 px-4 text-left font-nold text-base">Created On</th>
                      <th class="py-3 px-4 text-left font-bold text-base">Companies</th>
                      <th class="py-3 px-4 text-left font-bold text-base">Assets</th>
                      <th class="py-3 px-4 text-left font-bold text-base">External Scan Assets</th>
                    </tr>
                  </thead>
                  <tbody class="text-sm font-light overflow-y-auto">
                    <ng-container *ngFor="let item of partnerstatsDataValue; trackBy: trackByFn">
                      <tr class="border-b">
                        <td class="py-3 px-4 text-left font-light">{{item.created | utcToLocale}}
                        </td>
                        <td class="py-3 px-4 text-left font-light">
                          {{item.companies}}
                        </td>
                        <td class="py-3 px-4 text-left font-light">{{item.assets}}
                        </td>
                        <td class="py-3 px-4 text-left font-light">
                          {{item.external}}
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card class="modal" *ngIf="trailActionView === 'convert-to-paid' && convertToPaidData">
          <mat-card-header>
            <mat-card-title class="text-lg font-medium">Convert To Paid</mat-card-title>
            <div class="spacer">&nbsp;</div>
            <button class="mini-form-field" mat-icon-button aria-label="close modal icon" matTooltip="Close"
              (click)="drawerOpened = false">
              <mat-icon>close</mat-icon>
            </button>
          </mat-card-header>
          <mat-divider></mat-divider>
          <mat-card-content class="my-4" fuseScrollbar>
            <!-- <mat-form-field class="w-full mb-4">
              <mat-label>Choose Date</mat-label>
              <input matInput placeholder="Choose Date" type="date" required name="paiddays"
                [(ngModel)]="convertToPaidData.paid_start_date" />
            </mat-form-field> -->
            <mat-form-field class="w-full mb-4">
              <mat-label>From date</mat-label>
              <input matInput [matDatepicker]="picker1" [(ngModel)]="convertToPaidData.paid_start_date"
                autocomplete="off" name="startDate">
              <mat-hint>MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="w-full mb-4">
              <mat-label>Reason</mat-label>
              <textarea matInput placeholder="Add Reason" required name="reason"
                [(ngModel)]="convertToPaidData.reason"></textarea>
            </mat-form-field>
            <div class="flex items-center justify-end mt-4 p-2 border-t bg-gray-50 dark:bg-transparent ml-auto">
              <button class="ml-auto" mat-button [matTooltip]="'Cancel'"
                (click)="drawerOpened = false ;changeDistributorData={}">
                Cancel
              </button>
              <button class="ml-2" mat-flat-button [color]="'primary'" type="button" appPreventMultiClick
                [disabled]="!(convertToPaidData.paid_start_date && convertToPaidData.reason)" [matTooltip]="'Save'"
                (click)="saveConvertPaid(convertToPaidData)">
                Save
              </button>
            </div>
          </mat-card-content>
        </mat-card>
        <div *ngIf="trailActionView==='domain-details' ">
          <mat-card class="modal" *ngIf="domainDetails && domainDetails.length>0">
            <mat-card-header>
              <mat-card-title class="text-lg font-medium">{{domainDetails[0].tenant_name |
                camelToHuman:true}}</mat-card-title>
              <div class="spacer">&nbsp;</div>
              <button class="mini-form-field" mat-icon-button aria-label="close modal icon" matTooltip="Close"
                (click)="drawerOpened = false;domainDetails=[]">
                <mat-icon>close</mat-icon>
              </button>
            </mat-card-header>
            <mat-divider></mat-divider>
            <mat-card-content class="my-4" fuseScrollbar>
              <div class="w-full mx-auto">
                <mat-tab-group [selectedIndex]="selectedIndex" (selectedIndexChange)="tabFnDetails($event)" class=""
                  mat-stretch-tabs="false" [animationDuration]="'0'">
                  <mat-tab label="Company Details">
                    <ng-template matTabContent>
                      <ng-container *ngIf="domainDetails && domainDetails.length>0">
                        <div
                          class="flex flex-col flex-auto p-4 overflow-hidden w-full bg-white border border-gray-200 rounded-lg dark:bg-gray-800 dark:border-gray-700">
                          <div class="flex flex-col sm:flex-row items-start justify-between">
                            <div class="text-lg font-medium tracking-tight leading-6 truncate">
                              <span>
                                Total Companies
                                <span class="ml-1 px-2 bg-blue-400 text-black rounded py-0.5 text-sm">
                                  {{domainDetails[0].companies }}
                                </span>
                              </span>
                              <span class="ml-2">
                                Total Assets
                                <span class="ml-1 px-2 bg-blue-400 text-black rounded py-0.5 text-sm">
                                  {{domainDetails[0].assets }}
                                </span>
                              </span>
                            </div>
                          </div>
                          <div class="flex flex-col items-start border-t-2 mt-2 p-2">
                            <table class="text-medium text-left rtl:text-right text-gray-500 dark:text-gray-400">
                              <tbody>
                                <ng-container *ngFor="let detail of domainDetails[0].details;let i = index">
                                  {{i+1}}. {{detail.companyname | camelToHuman:true}}
                                  <tr>
                                    <td
                                      class="border px-4 py-2 font-bold w-40 text-blue-800 bg-blue-100 dark:text-blue-50 dark:bg-blue-500">
                                      Asset Count</td>
                                    <td class="border px-4 py-2 break-all">{{ detail.assetcount }}</td>
                                  </tr>
                                  <tr>
                                    <td
                                      class="border px-4 py-2 font-bold w-40 text-blue-800 bg-blue-100 dark:text-blue-50 dark:bg-blue-500">
                                      Company ID</td>
                                    <td class="border px-4 py-2 break-all">{{ detail.companyid }}</td>
                                  </tr>
                                  <tr>
                                    <td
                                      class="border px-4 py-2 font-bold w-40 text-blue-800 bg-blue-100 dark:text-blue-50 dark:bg-blue-500">
                                      Lightweight Agents Count</td>
                                    <td class="border px-4 py-2 break-all">{{ detail.lightweightagentscount }}</td>
                                  </tr>
                                  <tr>
                                    <td
                                      class="border px-4 py-2 font-bold w-40 text-blue-800 bg-blue-100 dark:text-blue-50 dark:bg-blue-500">
                                      Probe Count</td>
                                    <td class="border px-4 py-2 break-all">{{ detail.probecount }}</td>
                                  </tr>
                                </ng-container>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </ng-container>
                    </ng-template>
                  </mat-tab>
                  <mat-tab label="Company Stats">
                    <div>
                      <div class=" w-full rounded px-6 py-0.5 ring-1 mt-4" fuseScrollbar
                        *ngIf="domainDetails[0].details && domainDetails[0].details.length>0">
                        <table class="table-auto">
                          <thead>
                            <tr class="border-b">
                              <th class="py-3 px-4 text-left font-nold text-base">Company Name</th>
                              <th class="py-3 px-4 text-left font-nold text-base">Asset Count</th>
                              <th class="py-3 px-4 text-left font-bold text-base">Lightweight Agents Count</th>
                              <th class="py-3 px-4 text-left font-bold text-base">External Scan Assets Count</th>
                              <th class="py-3 px-4 text-left font-bold text-base">Probe Count</th>
                            </tr>
                          </thead>
                          <tbody class="text-sm font-light overflow-y-auto">
                            <ng-container *ngFor="let item of domainDetails[0].details; trackBy: trackByFn">
                              <tr class="border-b">
                                <td class="py-3 px-4 text-left font-light">{{item.companyname | camelToHuman:true}}
                                </td>
                                <td class="py-3 px-4 text-left font-light">
                                  {{item.assetcount}}
                                </td>
                                <td class="py-3 px-4 text-left font-light">{{item.lightweightagentscount}}
                                </td>
                                <td class="py-3 px-4 text-left font-light">
                                  {{item.externalscanassetscount}}
                                </td>
                                <td class="py-3 px-4 text-left font-light">
                                  {{item.probecount}}
                                </td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </div>
                      <div *ngIf="
                domainDetails[0].details && domainDetails[0].details.length===0
                    " class="flex flex-col items-center justify-center gap-y-2">
                        <img src="/assets/images/empty.png" alt="" class="w-20" />
                        <div>No data available!</div>
                      </div>
                      <!-- <stable aria-label="Domain Details" role="table" [sTableOptions]="allDomainTableOptions"></stable> -->
                    </div>
                  </mat-tab>
                </mat-tab-group>
              </div>

            </mat-card-content>
          </mat-card>
        </div>
        <div *ngIf="trailActionView==='tenant-user-details' && tenantUserDetailsData">
          <mat-card class="modal">
            <mat-card-header>
              <mat-card-title class="text-lg font-medium">User Details</mat-card-title>
              <div class="spacer">&nbsp;</div>
              <button class="mini-form-field" mat-icon-button aria-label="close modal icon" matTooltip="Close"
                (click)="closeMethod()">
                <mat-icon>close</mat-icon>
              </button>
            </mat-card-header>
            <mat-divider></mat-divider>
            <mat-card-content class="my-4" fuseScrollbar>
              <app-domain-details [details]="tenantUserDetailsData"></app-domain-details>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </mat-drawer>
    <mat-drawer-content class="h-full">
      <div>
        <stable aria-label="Assets Table" role="table" [sTableOptions]="trailPartnersTableOptions"
          *ngIf="trailPartnersTableOptions && trailPartnersTableOptions.tableOptions"
          (actionCallback)="actionCall($event)" (hyperlinkCallback)="linkClick($event)"></stable>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>
<s-modal id="suspendPartner">
  <mat-card class="modal w-[500px]" *ngIf="suspendPartnerdata">
    <mat-card-header>
      <mat-card-title class="text-lg font-medium">Suspend Confirmation
      </mat-card-title>
      <div class="spacer">&nbsp;</div>
      <button class="mini-form-field" mat-icon-button aria-label="close modal icon" matTooltip="Close"
        (click)="_modalService.close('suspendPartner')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-header>
    <p class="ml-5">
      Are you sure you want to suspend Partner?
    </p>
    <mat-divider></mat-divider>
    <mat-card-content class="my-4" fuseScrollbar>
      <mat-form-field class="w-full mb-4">
        <mat-label>Reason</mat-label>
        <textarea matInput placeholder="Add Reason" required name="reason"
          [(ngModel)]="suspendPartnerdata.reason"></textarea>
      </mat-form-field>
      <div class="flex items-center justify-end mt-4 p-2 border-t bg-gray-50 dark:bg-transparent ml-auto">
        <button class="ml-auto" mat-button [matTooltip]="'No'" (click)="_modalService.close('suspendPartner')">No</button>
        <button class="ml-2" mat-flat-button [color]="'primary'" type="button" appPreventMultiClick [matTooltip]="'Yes'"
          [disabled]="!suspendPartnerdata.reason" (click)="saveSuspendPartner(suspendPartnerdata)">
          Yes
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</s-modal>
<s-modal id="checkTrailEmailDetails">
  <mat-card class="modal w-[500px]">
    <mat-card-header>
      <mat-card-title class="text-lg font-medium">Check Email
      </mat-card-title>
      <div class="spacer">&nbsp;</div>
      <button class="mini-form-field" mat-icon-button aria-label="close modal icon" matTooltip="Close"
        (click)="_modalService.close('checkTrailEmailDetails');emailData=null">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-card-content class="my-4" fuseScrollbar>
      <mat-form-field class="w-full mb-4">
        <mat-label>Email</mat-label>
        <input matInput placeholder="Add Email" type="email" required name="email" [(ngModel)]="emailData" />
      </mat-form-field>
      <div class="flex items-center justify-end mt-4 p-2 border-t bg-gray-50 dark:bg-transparent ml-auto">
        <button class="ml-auto" mat-button [matTooltip]="'Cancel'" (click)="_modalService.close('checkTrailEmailDetails');emailData=null">
          Cancel
        </button>
        <button class="ml-2" mat-flat-button [color]="'primary'" type="button" appPreventMultiClick
          [disabled]="!emailData" [matTooltip]="'Submit'" (click)="checkEmail(emailData)">
          Submit
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</s-modal>
<s-modal id="tenantUserDetails">
  <mat-card class="modal w-[550px]" *ngIf="tenantUserDetails">
    <mat-card-header>
      <mat-card-title class="text-lg font-medium">Tenant Details
      </mat-card-title>
      <div class="spacer">&nbsp;</div>
      <button class="mini-form-field" mat-icon-button aria-label="close modal icon" matTooltip="Close"
        (click)="_modalService.close('tenantUserDetails')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-card-header>
    <mat-divider></mat-divider>
    <mat-card-content class="my-4" fuseScrollbar>
      <div class="text-lg font-medium tracking-tight leading-6 truncate">
        User: {{tenantUserDetails.message.split(' ')[1]}} <br> Tenant: {{tenantUserDetails.message.split(' ')[5]}}
      </div>    
      <div class="flex items-center justify-end mt-4 p-2 border-t bg-gray-50 dark:bg-transparent ml-auto">
        <button class="ml-auto" mat-button [matTooltip]="'Cancel'" (click)="_modalService.close('tenantUserDetails')">
          Cancel
        </button>
      </div>
    </mat-card-content>
  </mat-card>
</s-modal>